<script lang="ts">
  import type { BaseProps } from "#lib/internal/types"
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"
  import { getDialogRootContext } from "./DialogRoot.svelte"

  type Props = BaseProps<"div"> & {
    class?: string | undefined | null
    children?: Snippet
  }

  let { class: className = "", children, ...restProps }: Props = $props()

  const rootCtx = getDialogRootContext()
</script>

{#if $rootCtx.overlay}
  <div
    data-state={$rootCtx.open ? "open" : "closed"}
    class={cn(
      "fixed inset-0 z-30 bg-black/75 backdrop-blur-200 data-[state=open]:animate-show",
      className
    )}
    {...restProps}
  >
    {@render children?.()}
  </div>
{/if}
